<header class="header">
  <div class="logo-red" routerLink="/login"></div>
</header>


<div class="login-wrapper">
  <div class="login-card">
    <div class="isDivCreate" [style.display]="isDivCreate">
      <div class="title">
        <h2>{{ 'user.confirmLoginMfa.title' | transloco }}</h2>
        <p>{{ 'user.confirmLoginMfa.title2' | transloco }}</p>
      </div>
      <form class="sendCode" [formGroup]="form">
        <p-inputOtp formControlName="code" [integerOnly]="true" [length]="6" />
        <p-messages id="messages" [(value)]="messagesCode" [enableService]="false" [style]="{'font-size':'15px'}" />
        <div class="row">
          {{ 'user.confirmLoginMfa.resend' | transloco }} <a [routerLink]="[]" (click)="redirect()">{{
            'user.confirmLoginMfa.resend2' | transloco }}</a>
        </div>
      </form>
      <p-button (click)="onSubmit()" type="submit" severity="danger" [raised]="true" [loading]="isLoadingBtn"
        label="{{ 'user.confirmLoginMfa.btnSend' | transloco }}">
      </p-button>

    </div>

    <div class="isDivExpired" [style.display]="isDivExpired">
      <div class="container">
        <div class="title">
          <h1>{{ 'user.confirmLoginMfa.title4' | transloco }}</h1>
        </div>
        <p>{{ 'user.confirmLoginMfa.body5' | transloco }}
          <a id="expired" [routerLink]="[]" (click)="expired()">
            {{ 'user.confirmLoginMfa.body6' | transloco }}
          </a>
        </p>
      </div>
    </div>
  </div>
  <p-toast key="mfalogin" />
</div>

<footer class="footer" [ngStyle]="{'background-image': footerBackground}">
  <div class="footer-content">
    <div class="footer-logo">
      <img src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot" />
    </div>
    <div class="footer-bottom">
      <p>{{'footer.rightsReserved' | transloco }}</p>
    </div>
  </div>
</footer>